import { ReactElement } from 'react'
/**
 * This is a wrapper component to pass Combobox props to children
 * @param selected Boolean from Combobox component
 * @returns Wrapper to pass Combobox props to children
 */
export function CustomOption({
  selected,
  children,
}: {
  selected?: boolean
  children: (...args: any) => React.ReactElement
}): ReactElement {
  return <>{children({ selected })}</>
}
